import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from 'vue';
import BaseRule from '../BaseRule.vue';
export default {
  __name: 'DebtTotal',
  props: ['index'],
  setup(__props) {
    const props = __props;
    const index = computed(() => props.index);
    const word = {
      first: '信用类总负债不超过',
      second: '万',
      name: 'DebtTotal'
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(BaseRule, {
        word: word,
        index: _unref(index)
      }, null, 8, ["index"]);
    };
  }
};